import { useAuth } from "../../../AuthContext";

interface PrgInfo {
    depth?: string;
    p_code?: string;
    program_id?: string;
    prg_description?: string;
    sql?: string;
    input_date?: string;
    input_psn?: string;
    update_knd?: string;
    rollback_seq?: string;
    commit_msg?: string;
}

interface ProgramDescriptionTabProps {
    prgInfo: PrgInfo;
    setProgramInfo: React.Dispatch<React.SetStateAction<PrgInfo | null>>;
    programCreated: boolean;
}


export const AddProgramDescriptionTab = ({ prgInfo, setProgramInfo, programCreated }: ProgramDescriptionTabProps) => {

    const { user, userName } = useAuth();

    return (
        <div className=" h-full flex flex-col w-full bg-gray-900 text-body px-10 py-8">
            <form className="w-full">
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="block uppercase tracking-wide text-xs text-white  font-bold mb-2">
                            PROGRAM ID
                        </label>
                        <input
                            className="appearance-none border-none block w-full rounded bg-slate-500 bg-opacity-50 p-2 leading-tight outline-none text-white focus:bg-opacity-100 transition-all duration-300" id="nick" type="text" placeholder="Enter PROGRAM_ID ..."
                            disabled={programCreated}
                            value={prgInfo.program_id?.startsWith(prgInfo.p_code ?? "") ? prgInfo.program_id : `${prgInfo.p_code}${prgInfo.program_id}`}
                            onChange={(e) => {
                                const userEnteredText = e.target.value;

                                // Check if the user is attempting to delete the entire prefix
                                if (userEnteredText === prgInfo.p_code) {
                                    // If so, keep the prefix unchanged
                                    setProgramInfo({ ...prgInfo, program_id: prgInfo.p_code });
                                } else if (userEnteredText.startsWith(prgInfo.p_code ?? "")) {
                                    // If the user-entered text already starts with the prefix, use it as is
                                    setProgramInfo({ ...prgInfo, program_id: userEnteredText });
                                } else {
                                    // Otherwise, prepend the prefix to the user-entered text
                                    setProgramInfo({ ...prgInfo, program_id: `${prgInfo.p_code}${userEnteredText}` });
                                }
                            }}
                        />
                        <p className="text-gray-600 text-xs italic">Remove if not needed</p>
                    </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="lock uppercase tracking-wide text-xs text-white  font-bold pb-2">
                            Description
                        </label>

                        <textarea className=" no-resize appearance-none block w-full rounded bg-slate-500 bg-opacity-50 p-2 leading-tight outline-none text-white focus:bg-opacity-100 transition-all duration-300 h-48 resize-none"
                            id="message"
                            placeholder="Enter description ..."
                            value={prgInfo.prg_description}
                            onChange={(e) => setProgramInfo({ ...prgInfo, prg_description: e.target.value })}></textarea>
                        <p className="text-gray-600 text-xs italic">Re-size can be disabled by set by resize-none / resize-y / resize-x / resize</p>
                    </div>
                </div>

                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2">
                            First commit user
                        </label>
                        <p className="text-body  border-b border-b-gray-100 pb-2 px-2 italic">{userName}</p>
                    </div>
                </div>

                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3">
                        <label className="block uppercase tracking-wide text-white text-xs font-bold mb-2">
                            First commit date
                        </label>
                        <p className="text-body  border-b border-b-gray-100 pb-2 italic px-2">Date will be automatically inserted</p>
                    </div>
                </div>


            </form>
        </div>
    );
}

//export default ProgramDescriptionTab();

//onChange={(e) => setProgramInfo({ ...programInfo, program_id: e.target.value })} />